import stockApi from '../StockApi'

export async function findDescription(barcode, receivementId) {
  const { data } = await stockApi.get(`/v2/product/barcode/${barcode}`, {
    params: {
      receivement_id: receivementId
    }
  })
  return data
}
